export default __webpack_public_path__ + "static/media/template_intro.08fd2b48.png";